import * as types from "../../mutation-types";

const mutations = {
  [types.SET_SM_ORDERS]: (state, payload) => {
    state.sm_orders = payload;
  },
  [types.SET_SM_ORDER_TYPES]: (state, payload) => {
    state.sm_order_types = payload;
  },
};

export default mutations;
